interface Props {
  icon: 'excellent' | 'good' | 'fair' | 'poor';
}

const CreditRatingIcons = ({ icon }: Props) => {
  switch (icon) {
    case 'excellent':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1165_19143)">
            <path
              d="M17.3341 7.09834C16.3896 5.79544 16.4025 5.76299 15.3912 4.97881C14.3798 4.19463 12.0701 3.16354 10.1776 3.12577C8.28513 3.088 6.43139 3.66466 4.89429 4.7693C3.35719 5.87394 2.21954 7.44705 1.65191 9.2528C1.08428 11.0585 1.11723 12.9996 1.74584 14.7851C1.83197 15.0299 1.99174 15.242 2.20324 15.3924C2.41474 15.5427 2.66759 15.624 2.92709 15.6249H17.0732C17.3324 15.6251 17.5853 15.5446 17.7968 15.3947C18.0083 15.2448 18.1679 15.0328 18.2537 14.7882C18.6992 13.5215 18.8479 12.1695 18.6885 10.8363C18.5291 9.50307 18.0657 8.22424 17.3341 7.09834Z"
              fill="#03292E"
            />
            <path
              d="M19.3069 7.44531C19.4414 7.77217 19.2768 8.14525 18.9448 8.26637L9.70653 11.6363C9.37317 11.7579 9.00413 11.5878 8.87999 11.2554C8.75409 10.9182 8.92803 10.5431 9.26674 10.4215L18.5213 7.09653C18.8343 6.98408 19.1804 7.13772 19.3069 7.44531Z"
              fill="#03292E"
            />
            <path
              d="M19.888 8.55371C20.0224 8.88057 19.8579 9.25365 19.5258 9.37477L10.2876 12.7447C9.95422 12.8663 9.58518 12.6962 9.46105 12.3638C9.33514 12.0266 9.50908 11.6515 9.8478 11.5299L19.1023 8.20493C19.4153 8.09248 19.7614 8.24612 19.888 8.55371Z"
              fill="white"
            />
            <path
              d="M3.52119 13.17C3.27373 11.7995 3.46717 10.3859 4.07369 9.13238C4.68022 7.87881 5.66859 6.84984 6.89674 6.19338C8.12489 5.53691 9.52955 5.28676 10.9088 5.47888C12.2881 5.671 13.5709 6.29549 14.5729 7.2626"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1165_19143">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'good':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g opacity="0.8" clipPath="url(#clip0_1277_2516)">
            <path
              d="M17.3341 7.09834C16.3896 5.79544 16.4025 5.76299 15.3912 4.97881C14.3798 4.19463 12.0701 3.16354 10.1776 3.12577C8.28513 3.088 6.43139 3.66466 4.89429 4.7693C3.35719 5.87394 2.21954 7.44705 1.65191 9.2528C1.08428 11.0585 1.11723 12.9996 1.74584 14.7851C1.83197 15.0299 1.99174 15.242 2.20324 15.3924C2.41474 15.5427 2.66759 15.624 2.92709 15.6249H17.0732C17.3324 15.6251 17.5853 15.5446 17.7968 15.3947C18.0083 15.2448 18.1679 15.0328 18.2537 14.7882C18.6992 13.5215 18.8479 12.1695 18.6885 10.8363C18.5291 9.50307 18.0657 8.22424 17.3341 7.09834Z"
              fill="#0F3B40"
            />
            <path
              d="M15.754 3.37398C16.0327 3.59128 16.0746 3.99687 15.8462 4.2666L9.49135 11.7711C9.26204 12.0419 8.85722 12.077 8.58469 11.8498C8.30826 11.6193 8.27353 11.2073 8.50745 10.9338L14.8987 3.46029C15.1149 3.20752 15.4916 3.1695 15.754 3.37398Z"
              fill="#0F3B40"
            />
            <path
              d="M16.8077 4.04879C17.0864 4.26609 17.1283 4.67168 16.8999 4.9414L10.5451 12.4459C10.3158 12.7167 9.91093 12.7518 9.6384 12.5246C9.36198 12.2941 9.32724 11.8821 9.56116 11.6086L15.9524 4.13509C16.1686 3.88232 16.5454 3.8443 16.8077 4.04879Z"
              fill="white"
            />
            <path
              d="M3.52119 13.17C3.3322 12.1234 3.39957 11.0465 3.71751 10.0317C4.03546 9.01677 4.59453 8.094 5.34689 7.34231C6.09924 6.59061 7.0225 6.03235 8.03767 5.7153C9.05284 5.39824 10.1297 5.33183 11.1761 5.52173"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1277_2516">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'fair':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1277_2557)">
            <path
              d="M17.3341 7.09834C16.3896 5.79544 16.4025 5.76299 15.3912 4.97881C14.3798 4.19463 12.0701 3.16354 10.1776 3.12577C8.28513 3.088 6.43139 3.66466 4.89429 4.7693C3.35719 5.87394 2.21954 7.44705 1.65191 9.2528C1.08428 11.0585 1.11723 12.9996 1.74584 14.7851C1.83197 15.0299 1.99174 15.242 2.20324 15.3924C2.41474 15.5427 2.66759 15.624 2.92709 15.6249H17.0732C17.3324 15.6251 17.5853 15.5446 17.7968 15.3947C18.0083 15.2448 18.1679 15.0328 18.2537 14.7882C18.6992 13.5215 18.8479 12.1695 18.6885 10.8363C18.5291 9.50307 18.0657 8.22424 17.3341 7.09834Z"
              fill="#609399"
            />
            <path
              d="M8.87697 1.74567C9.23021 1.73362 9.5225 2.01792 9.52024 2.37135L9.45747 12.2048C9.4552 12.5597 9.16713 12.8463 8.81229 12.8467C8.45237 12.8471 8.16151 12.5533 8.16556 12.1935L8.27615 2.36039C8.27989 2.02781 8.54457 1.75701 8.87697 1.74567Z"
              fill="#609399"
            />
            <path
              d="M10.1182 1.58771C10.4714 1.57566 10.7637 1.85996 10.7615 2.21339L10.6987 12.0469C10.6964 12.4017 10.4083 12.6883 10.0535 12.6887C9.69358 12.6892 9.40273 12.3954 9.40677 12.0355L9.51736 2.20243C9.5211 1.86985 9.78578 1.59905 10.1182 1.58771Z"
              fill="white"
            />
            <path
              d="M3.52119 13.17C3.27753 11.8206 3.46125 10.4288 4.04672 9.18881C4.63219 7.94886 5.59018 6.92265 6.78698 6.25339"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1277_2557">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'poor':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1277_2536)">
            <path
              d="M17.3341 7.09834C16.3896 5.79544 16.4025 5.76299 15.3912 4.97881C14.3798 4.19463 12.0701 3.16354 10.1776 3.12577C8.28513 3.088 6.43139 3.66466 4.89429 4.7693C3.35719 5.87394 2.21954 7.44705 1.65191 9.2528C1.08428 11.0585 1.11723 12.9996 1.74584 14.7851C1.83197 15.0299 1.99174 15.242 2.20324 15.3924C2.41474 15.5427 2.66759 15.624 2.92709 15.6249H17.0732C17.3324 15.6251 17.5853 15.5446 17.7968 15.3947C18.0083 15.2448 18.1679 15.0328 18.2537 14.7882C18.6992 13.5215 18.8479 12.1695 18.6885 10.8363C18.5291 9.50307 18.0657 8.22424 17.3341 7.09834Z"
              fill="#B1CCCF"
            />
            <path
              d="M3.60894 3.8736C3.90195 3.67596 4.30056 3.76184 4.48618 4.06261L9.65075 12.4309C9.83711 12.7329 9.74501 13.1287 9.44446 13.3173C9.13963 13.5087 8.7372 13.414 8.54967 13.1068L3.42585 4.71345C3.25255 4.42957 3.33321 4.05959 3.60894 3.8736Z"
              fill="#B1CCCF"
            />
            <path
              d="M4.57671 3.08112C4.86972 2.88348 5.26833 2.96936 5.45395 3.27013L10.6185 11.6384C10.8049 11.9404 10.7128 12.3362 10.4122 12.5248C10.1074 12.7162 9.70498 12.6215 9.51744 12.3143L4.39362 3.92097C4.22032 3.63709 4.30098 3.26711 4.57671 3.08112Z"
              fill="white"
            />
            <path
              d="M3.52119 13.17C3.25137 11.6757 3.50632 10.1341 4.24285 8.80629"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1277_2536">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    default:
      return null;
  }
};

export default CreditRatingIcons;
